import {
    FETCH_AUTO_DETECTED_EVENTS,
    FETCH_AUTO_DETECTED_EVENTS_SUCCESS,
    FETCH_AUTO_DETECTED_EVENTS_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    payload: {},
    dailyEvents: {}
};

const fetchAutoDetectedEventsSuccess = (state, action) => {
    return {
        payload: action.autoDetectedEvents,
        dailyEvents: {
            ...state.dailyEvents,
            [action.displayName]: {
                ...state.dailyEvents[action.displayName],
                [action.calendarDate]: action.autoDetectedEvents
            }
        }
    };
};

const fetchAutoDetectedEventsFail = (state, action) => {
    return {
        payload: action.autoDetectedEvents,
        dailyEvents: state.dailyEvents
    };
};

const handlers = {
    [FETCH_AUTO_DETECTED_EVENTS_SUCCESS]: fetchAutoDetectedEventsSuccess,
    [FETCH_AUTO_DETECTED_EVENTS_FAIL]: fetchAutoDetectedEventsFail
};

export default function autoDetectedEvents(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchAutoDetectedEvents(displayName, calendarDate, evictCache) {
    return {
        type: FETCH_AUTO_DETECTED_EVENTS,
        displayName: displayName,
        calendarDate: calendarDate,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export const getAutoDetectedEvents = (state, displayName, calendarDate) => {
    return state.autoDetectedEvents.dailyEvents[displayName]
        ? state.autoDetectedEvents.dailyEvents[displayName][calendarDate]
        : [];
};
